export enum AboDetailActionType {
  Link,
  Modal,
  StoreAction
}
